import React from 'react';
import { Cell, Row } from 'react-table';
import cx from 'classnames';

import { IconErrorCircle } from '@trqk/components';

import { useModal } from '../../../../../hooks';
import { DeleteEntityModalContent } from '.';

interface DeleteEntityCellProps {
    cell: Cell<EntityWithUploadedStatements>;
    column: DeleteDataByIndexColumn<EntityWithUploadedStatements>;
    row: Row<EntityWithUploadedStatements>;
}

/**
 * A react-table cell that renders a button to allow the user to delete an entity.
 * @param props {DeleteEntityCellProps}
 */
export function DeleteEntityCell({
    cell,
    column,
    row,
}: DeleteEntityCellProps): JSX.Element {
    const { deleteTableRowByIndex } = column;
    const { index } = row;
    const modal = useModal();
    const {
        value: { entityId, userId, ROW_LOCK },
    } = cell;

    const disabled = ROW_LOCK !== null && ROW_LOCK.length > 0;
    const iconFill = disabled ? 'tertiary-300' : 'black';

    return (
        <button
            disabled={disabled}
            type="button"
            className={cx({
                'cursor-default': disabled,
            })}
            onClick={(): void => {
                modal.add({
                    Content: DeleteEntityModalContent,
                    input: {
                        deleteTableRowByIndex,
                        entityId,
                        index,
                        userId,
                    },
                });
            }}
        >
            <IconErrorCircle width={16} addClasses="m-1" fillColor={iconFill} />
        </button>
    );
}
